import ActionModal from "components/blocks/Modal/ActionModal";
import useMutation from "hooks/useMutation";
import { useTranslation } from "react-i18next";
import { ExaminersService } from "services/examinersService";
import { ExaminerResult } from "services/examinersService/Model/ExaminerTypes";
import { BaseResponseType } from "services/shared-models/sharedTypes";
import {RefereesService} from "../../../../../../../../services/RefereeService";
import {CourseOrderService} from "../../../../../../../../services/courseOrder";

export type AddIterationsRefereeModalProps = {
  isOpen: boolean;
  onClose: (shouldUpdateExaminersTable: boolean) => void;
  selectedCourseOrderEvaluationId: number;
};

export const AddIterationsRefereeModal = ({ props }: { props?: AddIterationsRefereeModalProps | null }) => {
  const { t } = useTranslation(["Orders"]);
  const { mutateAsync: UpdateRefereeEvaluationOrderIterationsAsync, loading: UpdateRefereeEvaluationOrderIterationsLoading } = useMutation({
    queryFn: async (selectedCourseOrderEvaluationId: number) => {
      return await CourseOrderService.UpdateRefereeEvaluationOrderIterations(selectedCourseOrderEvaluationId);
    },
  });



  const onConfirm= async () => {
    let res: BaseResponseType<any>;
    res = (await UpdateRefereeEvaluationOrderIterationsAsync(props!.selectedCourseOrderEvaluationId)) as BaseResponseType<any>;
    if (!res.hasError) {
      props!.onClose(true);
    }
  };

  return (
    <ActionModal
      isOpen={props?.isOpen}
      onClose={() => props?.onClose(false)}
      headerMsg={t("AddIterationsRefereeModalHeaderMsg")}
      subMsg={t("AddIterationsRefereeModalSubMsg")}
      confirmBtnText={t("AddIteration")}
      actionIcon="icon-orders"
      iconWrapperColor="primary"
      onActionConfirm={onConfirm}
      loading={UpdateRefereeEvaluationOrderIterationsLoading}
    />
  );
};
